import { useEffect } from 'react';

import useBoolean from '@front/common/src/hooks/use-boolean';
import { useModalObject } from '@front/common/src/hooks/use-modal';
import type { CleaningPrestation } from '@front/common/src/types/commons';

export type UseRecurringCleaningPromoArgs = {
  isPromotionValid?: boolean;
  cleaningPrestation?: CleaningPrestation;
};

const useRecurringCleaningPromo = ({ isPromotionValid = false, cleaningPrestation }: UseRecurringCleaningPromoArgs) => {
  const { isOpen, open, close } = useModalObject();
  const { value: shouldShowModal, setValue: setShouldShowModal } = useBoolean(false);

  useEffect(() => {
    // We first check if we should show the modal with the current params
    const shouldShowNow = !!cleaningPrestation?.is_recurrent && isPromotionValid;
    // If we should show the modal with the current params and it was not the case before we open it
    // If it was the case before we do nothing to avoid to show again when we add options on a recurring prestation
    if (!shouldShowModal && shouldShowNow) open();
    setShouldShowModal(shouldShowNow);
  }, [isPromotionValid, open, cleaningPrestation, shouldShowModal, setShouldShowModal]);

  return { isOpen, close };
};

export default useRecurringCleaningPromo;
